import { featureFlagsListQueryOptions } from '@/api/queries/core';
import { FeatureFlag } from '@/common';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';

export function useIsFeatureFlagEnabled(featureFlag: FeatureFlag): {
  enabled: boolean;
  isLoading: boolean;
};
export function useIsFeatureFlagEnabled(featureFlags: FeatureFlag[]): {
  enabled: boolean[];
  isLoading: boolean;
};

/**
 * Hook to check if a feature flag or multiple feature flags are enabled for the current user.
 * @param featureFlagOrFlags - A single feature flag or an array of feature flags to check.
 * @returns A boolean indicating if the feature flag is enabled, or an array of booleans for multiple flags.
 */
export function useIsFeatureFlagEnabled(
  featureFlagOrFlags: FeatureFlag | FeatureFlag[]
): { enabled: boolean; isLoading: boolean } | { enabled: boolean[]; isLoading: boolean } {
  const { user } = useAuth();

  const { data: featureFlagsList, isLoading } = useQuery(
    featureFlagsListQueryOptions(user?.user_id)
  );

  return {
    enabled: Array.isArray(featureFlagOrFlags)
      ? featureFlagOrFlags.map(
          flag => featureFlagsList?.flags.find(f => f.flag === flag)?.enabled ?? false
        )
      : featureFlagsList?.flags.find(f => f.flag === featureFlagOrFlags)?.enabled ?? false,
    isLoading,
  };
}
